import React from "react";
import logo from "../assets/logo.png";

function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior:"smooth" });
  };

  return (
    <footer style={{background:"#0f172a", borderTop:"3px solid #0d9488", color:"#fff", padding:"56px 48px 32px"}}>
      <div style={{display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:"40px", marginBottom:"48px"}}>
        <div style={{maxWidth:"280px"}}>
          <img src={logo} alt="Sajilo Policy" style={{height:"80px", objectFit:"contain", marginBottom:"16px", filter:"brightness(2)"}} />
          <p style={{color:"#64748b", fontSize:"14px", lineHeight:"1.8", marginBottom:"12px"}}>Nepal's most affordable microinsurance platform. Protecting every Nepali, one policy at a time. 🇳🇵</p>
          <p style={{color:"#0d9488", fontSize:"13px", fontWeight:"700", marginBottom:"16px"}}>🤝 Partnered with Himalayan Life Insurance</p>
          <div style={{display:"flex", gap:"12px", flexWrap:"wrap"}}>
            {["eSewa", "Khalti", "ConnectIPS"].map((p) => (
              <div key={p} style={{background:"rgba(13,148,136,0.1)", border:"1px solid rgba(13,148,136,0.3)", color:"#2dd4bf", padding:"6px 12px", borderRadius:"8px", fontSize:"11px", fontWeight:"700"}}>{p}</div>
            ))}
          </div>
        </div>
        <div>
          <h4 style={{color:"#2dd4bf", fontWeight:"800", marginBottom:"16px", fontSize:"14px", letterSpacing:"1px"}}>PLANS</h4>
          {[["Hospital Cash","plans"],["Personal Accident","plans"],["Travel Insurance","plans"],["Bike & Scooter","plans"],["Family Floater","plans"],["Crop Protection","plans"]].map(([label, id]) => (
            <div key={label} onClick={() => scrollTo(id)} style={{color:"#64748b", fontSize:"14px", marginBottom:"10px", cursor:"pointer", transition:"color 0.2s"}}
              onMouseEnter={e => e.target.style.color="#2dd4bf"}
              onMouseLeave={e => e.target.style.color="#64748b"}>
              {label}
            </div>
          ))}
        </div>
        <div>
          <h4 style={{color:"#2dd4bf", fontWeight:"800", marginBottom:"16px", fontSize:"14px", letterSpacing:"1px"}}>COMPANY</h4>
          {[["About Us","about"],["How It Works","howitworks"],["FAQ","faq"],["Contact","contact"]].map(([label, id]) => (
            <div key={label} onClick={() => scrollTo(id)} style={{color:"#64748b", fontSize:"14px", marginBottom:"10px", cursor:"pointer", transition:"color 0.2s"}}
              onMouseEnter={e => e.target.style.color="#2dd4bf"}
              onMouseLeave={e => e.target.style.color="#64748b"}>
              {label}
            </div>
          ))}
        </div>
        <div>
          <h4 style={{color:"#2dd4bf", fontWeight:"800", marginBottom:"16px", fontSize:"14px", letterSpacing:"1px"}}>CONTACT</h4>
          <div style={{color:"#64748b", fontSize:"14px", marginBottom:"10px"}}>📞 01-XXXXXXX</div>
          <div style={{color:"#64748b", fontSize:"14px", marginBottom:"10px"}}>📧 hello@sajilo.com.np</div>
          <div style={{color:"#64748b", fontSize:"14px", marginBottom:"20px"}}>📍 Kathmandu, Nepal</div>
          <div style={{display:"flex", gap:"12px"}}>
            {["Facebook","Instagram","Twitter"].map((s) => (
              <div key={s}
                style={{background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)", color:"#94a3b8", padding:"8px 12px", borderRadius:"8px", fontSize:"12px", cursor:"pointer", transition:"all 0.2s"}}
                onMouseEnter={e => { e.target.style.background="rgba(13,148,136,0.15)"; e.target.style.color="#2dd4bf"; e.target.style.borderColor="rgba(13,148,136,0.4)"; }}
                onMouseLeave={e => { e.target.style.background="rgba(255,255,255,0.05)"; e.target.style.color="#94a3b8"; e.target.style.borderColor="rgba(255,255,255,0.1)"; }}>
                {s}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{borderTop:"1px solid rgba(255,255,255,0.06)", paddingTop:"24px", display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:"12px"}}>
        <span style={{color:"#334155", fontSize:"13px"}}>© 2025 Sajilo Policy Pvt. Ltd. | In partnership with Himalayan Life Insurance</span>
        <span style={{color:"#334155", fontSize:"13px"}}>Privacy Policy · Terms of Service</span>
      </div>
    </footer>
  );
}

export default Footer;